module.exports = ".my-expansion {\n  margin-top: 1em !important; }\n\n.alignbutton {\n  margin-top: 5px; }\n\n.colorRed {\n  color: #DF5353; }\n"